import React, { ChangeEvent, useState } from 'react';
import { Box, SxProps } from '@mui/material';
import { CounterWrapper, CounterButton, CounterDisplay, CounterInput } from './NumberInput.styles';
import { sharedClasses } from '../sharedClasses';

interface NumberInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  sx?: SxProps;
  buttonSx?: SxProps;
  inputSx?: SxProps;
  errorText?: string;
}

export const NumberInput = ({
  value,
  onChange,
  min,
  max,
  sx,
  buttonSx,
  inputSx,
  errorText
}: NumberInputProps) => {
  const [inputValue, setInputValue] = useState(String(value));

  const handleIncrement = () => {
    if (max === undefined || value < max) {
      onChange(value + 1);
      setInputValue(String(value + 1));
    }
  };

  const handleDecrement = () => {
    if (min === undefined || value > min) {
      onChange(value - 1);
      setInputValue(String(value - 1));
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    const numVal = Number(val);

    if (val.length > 3 || isNaN(numVal)) return;

    setInputValue(val);
    onChange(numVal);
  };

  return (
    <Box>
      <CounterWrapper sx={sx}>
        <CounterButton
          onClick={handleDecrement}
          sx={{ borderTopLeftRadius: 5, borderBottomLeftRadius: 5, ...buttonSx }}
        >
          -
        </CounterButton>
        <CounterDisplay>
          <CounterInput
            value={inputValue}
            onChange={handleInputChange}
            sx={inputSx}
            error={!!errorText}
            inputMode="numeric"
          />
        </CounterDisplay>
        <CounterButton
          onClick={handleIncrement}
          sx={{ borderTopRightRadius: 5, borderBottomRightRadius: 5, ...buttonSx }}
        >
          +
        </CounterButton>
      </CounterWrapper>
      {!!errorText && <Box sx={sharedClasses.errorText}>{errorText}</Box>}
    </Box>
  );
};
